"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("../tokens");

var parseColor = function parseColor(themeColor) {
  return "".concat(_tokens.colors[themeColor.color + themeColor.scale]);
};

var _default = parseColor;
exports.default = _default;